import React, { useState } from "react";
import { Row, Col, Card, Form, Input, Spin, PageHeader, Alert } from "antd";
import { useSelector } from "react-redux";
import { CustomBtn } from "../../../components/Button";
import { useBillAgriVoucherEnlevementMutation } from "../service/bill-api";
import TransactionResume from "../../../components/Dialog/transaction-resume";
import SuccessDialog from "../../../components/Dialog/success";

export function BillAgrivoucherEnlevementPage() {
  const { currentAgent } = useSelector((state) => state.auth);
  const [billAgriVoucherEnlevement] = useBillAgriVoucherEnlevementMutation();
  const [show, setShow] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const [isCustomer, setIsCustomer] = useState(false);
  const [formdata, setFormData] = useState();
  const [form] = Form.useForm();

  const handleSearch = async (value) => {
    setShow(true);
    setFormData(value)
    setIsCustomer(true);
  };

  const handlePay = async (pin) => {
    setIsLoading(true);
    setShow(false);
    const data = {
      agent_msisdn: currentAgent.phone,
      code_bon: formdata.code_bon,
      distributor_contact: currentAgent.phone,
      agent_pin: pin,
      transaction_id: formdata.transaction_id
    };

    billAgriVoucherEnlevement(data)
      .unwrap()
      .then(() => {
        setIsSuccess(true);
        setIsLoading(false);
        setIsCustomer(false);
        form.resetFields();
      })
      .catch((error) => {
        setIsLoading(false);
        setError(error.data.error);
      });
  };

  return (
    <div className="default-page">
      <TransactionResume
        title="AGRIVOUCHER ENLEVEMENT"
        message={"Vous allez effectuer un enlevement AGRIVOUCHER"}
        fees={"0"}
        status={show}
        handleCancel={() => setShow(false)}
        handlePay={handlePay}
      />
      <SuccessDialog
        message="Enlevement effectué avec succès"
        status={isSuccess}
        handleCancel={() => setIsSuccess(false)}
      />
      <PageHeader title="AGRIVOUCHER ENLEVEMENT" />
      <Spin tip="Chargement..." spinning={isLoading}>
        <Row gutter={16}>
          <Col lg={12} xs={24}>
            <Card>
              <Form name="basic" form={form} layout="vertical" onFinish={isCustomer ? handlePay : handleSearch}>
                <Form.Item
                  label="Code Bon"
                  name="code_bon"
                  rules={[{ required: true, message: "Veuillez saisir le code bon" }]}>
                  <Input className="form-control" placeholder="Code Bon" />
                </Form.Item>

                <Form.Item
                  label="REf Transaction"
                  name="transaction_id"
                  rules={[{ required: true, message: "Champs requis" }]}>
                  <Input className="form-control" placeholder="Réference" />
                </Form.Item>
                {error && (
                  <Form.Item>
                    <Alert message={error} type="error" showIcon />
                  </Form.Item>
                )}
                <Form.Item>
                  <CustomBtn title="Valider" />
                </Form.Item>
              </Form>
            </Card>
          </Col>
        </Row>
      </Spin>
    </div>
  );
}
export default BillAgrivoucherEnlevementPage;
